import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { BookkeepersCompanyIncidenceStatFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'

import StatBlock from 'modules/bookkeepers/components/StatBlock'
import {
  calculateTotal,
  calculateTypeTotal,
} from 'modules/payroll_bundle/lib/Incidences/IncidenceFilters'

const getIncidenceForStatusStats = createComputed(
  (stats: BookkeepersCompanyIncidenceStatFragment[], status: string) => {
    const resultStats = stats.find((stat) => stat.status === status)
    const total = resultStats ? calculateTotal(resultStats) : 0
    const typeTotal = resultStats ? calculateTypeTotal(resultStats) : undefined

    return {
      incidenceStatsData: total,
      incidenceTypeStats: typeTotal,
    }
  }
)

interface Props {
  stats: BookkeepersCompanyIncidenceStatFragment[]
  status: string
  label: string
  hasBorder?: boolean
}

const StatsByStatus = ({ stats, status, label }: Props) => {
  const { incidenceStatsData, incidenceTypeStats } = getIncidenceForStatusStats(stats, status).get()

  return (
    <Box width="s240">
      <StatBlock name={label} value={incidenceStatsData} typeStats={incidenceTypeStats} />
    </Box>
  )
}

export default observer(StatsByStatus)
